import { Component, OnInit } from '@angular/core';
import { TimesheetApprovalsService } from '../timesheet-approvals.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rejected-timesheet-details',
  templateUrl: './rejected-timesheet-details.component.html',
  styleUrls: ['./rejected-timesheet-details.component.css']
})
export class RejectedTimesheetDetailsComponent implements OnInit {
  @SessionStorage() public user;
  public rejectedList: any = [];
  public dateRange: any = [];
  public daysList: any = [];
  public temporaryList: any = [];

  constructor(
    public dashboardService: DashboardService,
    public timesheetApprovalsService: TimesheetApprovalsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.getRejectedLists();
  }

  /**function to get rejected list */
  getRejectedLists() {
    this.rejectedList = [];
    const obj = {
      'userDetails': {
        'Empno': this.user.Empno
      }
    };
    this.dashboardService.getDashboard(obj).subscribe(
      (data) => {
        if (data.payload.rejectedTimesheetList) {
          data.payload.rejectedTimesheetList.forEach((value, i) => {
            this.daysList[i] = [];
            this.temporaryList.push(value);
            this.rejectedList.push(value);
            const year = new Date().getFullYear();
            const week = value.weekNumber - 1;
            const d = new Date('Jan 01, ' + year + ' 01:00:00');
            const w = d.getTime() + 604800000 * (week);
            const startday = new Date(w);
            const endday = new Date(w + 518400000);
            const start = new Date(startday);
            const end = new Date(endday);
            const from = new Date(start.setDate(startday.getDate() - 1)).toLocaleDateString();
            const to = new Date(end.setDate(endday.getDate() - 1)).toLocaleDateString();
            this.dateRange.push(from + ' - ' + to);
            value.timesheetList.forEach(element => {
              const date = element.dateDetails.date;
              const dayOfWeek = new Date(date).getDay();
              // tslint:disable-next-line:max-line-length
              const days = (isNaN(dayOfWeek)) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
              if (!this.daysList[i].includes(days)) {
                this.daysList[i].push(days);
              }
            });
          });
        }
      }
      );
  }

  /**function to get timesheet based on role*/
  timeSheet(row, weekNumber) {
    const data = {
      'employeenumber': row.userDetails.Empno
    };
    const year = row.timesheetList[0].dateDetails.Year ?  row.timesheetList[0].dateDetails.Year : new Date().getFullYear();
    this.timesheetApprovalsService.setSelectedRowData(data, weekNumber, year);
    this.router.navigate(['rm/timesheet-entry']);
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/rejected-timesheet-details/rejected-timesheet-details.component.ts